import { MainListHeader } from 'src/components/MainListView/MainListHeader/MainListHeader';

export default function BrandLayout({ children }) {
  return (
    <>
      <MainListHeader />
      {children}
    </>
  );
}
